module.exports = "https://neera-retreat.sgp1.cdn.digitaloceanspaces.com/assets/rooms/pond/pond-02slide_02.png";